<template>
  <div class="container">
    <div class="header">
      <div class="header_text">
        <p>
          根据《四川省党员教育师资库管理办法（试行）》，省市县三级同步、上下联动建立师资库，规模为省级200人左右、市级80至100人左右、县级30至50人左右。
        </p>
        <p>
          省级师资库采取自下而上逐级推荐方式，在21个市（州）和省直机关工委、省委教育工委、省国资委报送的280名师资人选基础上，择优遴选200名。从结构类别上：党员领导干部28名、优秀党校教师28名、基层党组织书记26名、先进模范人物30名、党务工作者25名、专家学者27名、实用技术人才15名、离退休干部13名、土专家田秀才8名；从授课类型上：政治理论77名、革命传统16名、形势政策23名、工作实务62名、典型事迹22名。
        </p>
        <p>
          市县两级均按要求应建尽建，其中，21个市级师资库、入库师资2134名、平均101名，183个县级师资库、入库师资6721名、平均36名。
        </p>
      </div>
    </div>
    <div class="content">
      <!-- 省级师资库 -->
      <PLevelPool />
      <!-- 市级师资库 -->
      <MLevelPool v-if="showList" />
      <!-- 县级师资库 -->
      <CountryLevelPool v-if="showList" />
    </div>
    <Footer />
  </div>
</template>

<script setup>
import Footer from "./components/footer.vue";
import PLevelPool from "./components/pLevelPool.vue";
import MLevelPool from "./components/mLevelPool.vue";
import CountryLevelPool from "./components/countryLevelPool.vue";
import { ref, onMounted, reactive, watch } from "vue";
import { setDict, getCode } from "../../utils/dict";
import { szkGet } from "../../api/common";
const provincelocalList = ref([]); // 位置信息
const education = ref([]); // 教育字典
const courseList = ref([]); // 师资类别
const showList = ref(false);
// window.localStorage.setItem("code", code)
function getBaseCode() {
  szkGet({}, "/services/app/BaseCode/GetAllBaseCodes").then((res) => {
    window.localStorage.setItem("code", JSON.stringify(res));
    showList.value = true;
  });
}
getBaseCode();
onMounted(async () => {

  // const data = await getCode('LectureCategory', 'AdminArea', 'Education');
  // provincelocalList.value = data['AdminArea'][0].children;
  // courseList.value = data['LectureCategory'];
  // education.value = data['Education'];
});
</script>

<style lang="scss">
.container {
  overflow: auto;
}

.header {
  height: 481px;
  background: url(../../assets/images/header.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
}

.content {
  //   height: 2500px;
  //   position: relative;
  background-color: #fdf7f5;
}

.header_text {
  font-size: 14px;
  // background: url("../../assets/images/text_bg.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  color: #7b1818;
  left: 0;
  right: 0;
  width: 703px;
  height: 230px;
  margin: 190px auto 0;
  background-color: rgba(253, 227, 205, 0.4);
  padding: 10px;
  border-radius: 10px;
  line-height: 24px;

  p {
    text-indent: 2em;
  }
}
</style>
